class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.style.pointerEvents = 'all'
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (!localStorage.getItem('postal_code') || !localStorage.getItem('delivery_city')) {
      const deliveryPopup = document.querySelector('delivery-popup') || null;
      deliveryPopup?.showPopup(deliveryPopup);
      return;
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    this.openOrderInstuctions()
  }

  openOrderInstuctions() {
    const {dataset:{amountReached},classList} = document.querySelector(".cart__checkout-button");
    const isDisabledClass = [...classList].includes("cart__checkout-button--no-instructions");
    const orderContent = document.querySelector(".order-instuctions__content");
    if (amountReached === "true" && isDisabledClass === true) {
      orderContent.classList.add("order-instuctions__content--opened")
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      //this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();

    this.drawer = this.closest('#CartDrawer') || null;
    this.expressShippingBanner = this.querySelector('.drawer__express-shipping-banner') || null;
    this.isExpressShippingBannerShowed = localStorage.getItem('is_express_shipping_banner_showed') || null;
  }

  connectedCallback() {
    this.drawer && this.setCheckoutButtonBehaviourByNote()
    this.toggleExpressShippingBanner();
  }

  setCheckoutButtonBehaviourByNote() {
    const checkoutButton = this.drawer.querySelector('.cart__checkout-button') || null;

    checkoutButton?.addEventListener('click', (event) => {
      if (event.target.classList.contains('cart__checkout-button--no-instructions')) {
        event.preventDefault();

        const orderInstructions = this.drawer.querySelector('order-instructions');
        orderInstructions?.classList.add('order-instructions--not-setted');
        orderInstructions?.toggleInstructions();
      }
    });
  }

  toggleExpressShippingBanner() {
    const isBannerShowed = !this.isExpressShippingBannerShowed || this.isExpressShippingBannerShowed == 'false' || this.isExpressShippingBannerShowed == 'undefined' ? false : true
    this.expressShippingBanner?.classList.toggle('drawer__express-shipping-banner--visible', isBannerShowed)
  }


  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class OrderInstructions extends HTMLElement {
  constructor () {
    super();

    this.currentOptionElement = this.querySelector('.order-instuctions__option-value');
    this.currentOptionTextWrapper = this.currentOptionElement.querySelector('b');
    this.instructionWrapper = this.querySelector('.order-instuctions__content');
    this.instructionsArray = this.instructionWrapper.querySelectorAll('.instruction');
    this.instructionManualInput = this.instructionWrapper.querySelector('.instruction--manual-input');

    this.instructionsNoteInput = this.querySelector('.order-instuctions__note-input');
    this.currentValueFirstPart = '';
    this.instructionsArrowsSvg = this.querySelectorAll(".content__heading svg");
    this.buttonInstructionManual = this.querySelector(".instruction--manual");
    this.messageErrorText = this.querySelector(".content__error");
  }

  connectedCallback() {
    this.instructionsArray.forEach(instruction => {
      instruction.addEventListener('click', (event) => this.setOrderInstruction(instruction, event))
    })

    this.currentOptionElement.addEventListener('click', () => this.toggleInstructions())
    this.instructionManualInput.addEventListener('change', () => this.setManualInstrutionsInput(this.instructionManualInput, this.currentValueFirstPart))
    this.instructionManualInput.addEventListener('blur', this.validateInstructions.bind(this))
    this.instructionsNoteInput.addEventListener('change', (event) => this.setCartNote(event))
    this.instructionsArrowsSvg.forEach( arrowSvg => arrowSvg.addEventListener("click", this.toggleInstructions.bind(this) ) )
  }

  toggleInstructions() {
    this.instructionWrapper.classList.toggle('order-instuctions__content--opened');
  }

  setOrderInstruction(element, event) {
    let currentValue = (element.textContent?.replace(/\n/g, "")?.trim()) || "";
    
    this.instructionsArray.forEach(instruction => instruction.classList.remove('instruction--active'));
    element.classList.add('instruction--active');
  
    if (element.classList.contains('instruction--manual')) {
      this.handleManualInstruction(currentValue, event);
    } else {
      this.handleNonManualInstruction(currentValue);
    }
  }
  
  handleManualInstruction(currentValue, event) {
    this.instructionManualInput.focus();
    this.currentValueFirstPart = currentValue;
  
    if (this.isInstructionManualInputValid() == true) {
      currentValue = `${currentValue} (${this.instructionManualInput.value})`;
  
      if (event.target !== this.instructionManualInput) {
        this.toggleInstructions();
      }
    }
  
    this.updateInstructionsNoteInput(currentValue);
  }
  
  handleNonManualInstruction(currentValue) {
    this.updateInstructionsNoteInput(currentValue);
  
    this.classList.remove('order-instructions--not-setted');
    const checkoutButton = this.closest('.drawer__footer')?.querySelector('.cart__checkout-button');
    checkoutButton?.classList.remove('cart__checkout-button--no-instructions');
  
    this.currentOptionTextWrapper.innerHTML = currentValue;
  
    this.toggleInstructions();
  }
  
  updateInstructionsNoteInput(value) {
    this.instructionsNoteInput.value = value;
    this.instructionsNoteInput.dispatchEvent(new Event('change'));
    this.currentOptionTextWrapper.innerHTML = value;
  }

  setManualInstrutionsInput(manualInstruction, currentValueFirstPart) {
    if (manualInstruction.closest('.instruction--manual.instruction--active') && this.isInstructionManualInputValid() == true) {
      const manualValue = manualInstruction.value?.trim();
      const newValue = manualValue.length ? `${currentValueFirstPart} (${manualValue})` : currentValueFirstPart;

      this.updateInstructionsNoteInput(newValue);
      this.toggleInstructions();
    }
  }

  setCartNote(event) {
    if (!this.isValueFromManualInput()) {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    } 

    if (this.isValueFromManualInput() && this.isInstructionManualInputValid()) {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }

    if (this.isInstructionManualInputValid() == true) {
      this.classList.remove('order-instructions--not-setted');
      const checkoutButton = this.closest('.drawer__footer')?.querySelector('.cart__checkout-button');
      checkoutButton?.classList.remove('cart__checkout-button--no-instructions');
    }
  }

  validateInstructions() {
    if (!this.isInstructionManualInputValid()) {
      this.showErrorMessage();
      const checkoutButton = this.closest('.drawer__footer')?.querySelector('.cart__checkout-button');
      checkoutButton?.classList.add('cart__checkout-button--no-instructions');
    } 
  }


  isInstructionManualInputValid() {
    const inputValue = this.instructionManualInput.value?.trim();
    const minLength = 2;
      
    return inputValue && inputValue.length > minLength;
  }

  isValueFromManualInput(){
      return this.buttonInstructionManual.classList.contains("instruction--active");
  }

  showErrorMessage() {
    if (!this.messageErrorText) return;
    this.messageErrorText.classList.add("content__error--show");

    setTimeout(() => {
      this.messageErrorText.classList.remove("content__error--show");
    }, 2000);
  }

  
}

customElements.define('order-instructions', OrderInstructions)

class DrawerUpsells extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.drawer-upsells__slider') || null;
    this.upsellTitleElement = this.slider?.querySelector('.drawer-upsells__upsell-title');
    this.deliveryCity = localStorage.getItem('delivery_city') || null;
  }

  connectedCallback() {
    this.initSlider(this.slider)
    this.slider.swiper?.on('slideChange', (event) => this.setUpsellTitle(event))
    this.setDefaultSlideByCity(this.slider.swiper)
  }

  initSlider(slider) {
    if (slider && typeof window.Swiper != 'undefined') {
      return new Swiper(slider, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        watchSlidesProgress: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoHeight: true,
        navigation: {
          prevEl: '.drawer-upsells__navigation--prev',
          nextEl: '.drawer-upsells__navigation--next'
        }
      }) 
    }
  }

  setDefaultSlideByCity(slider) {
    if (!slider || !this.deliveryCity) return

    const slideIndex = slider.slides?.findIndex((slide) => {
      const slideTitleLower = slide.dataset.upsellTitle?.toLowerCase();
      const deliveryCiryLower = this.deliveryCity.toLowerCase();
      return slideTitleLower?.includes(deliveryCiryLower)
    })

    if (slideIndex !== -1) slider.slideTo(slideIndex)
  }

  setUpsellTitle(event) {
    const activeSlide = event.slides[event.activeIndex];
    const currentUpsellTitle = activeSlide?.dataset.upsellTitle;

    this.upsellTitleElement.innerHTML = currentUpsellTitle
  }
}

customElements.define('drawer-upsells', DrawerUpsells)
